<template>
   <div>
       <b-modal id="prevmodal" size="lg" title="Vista Previa" cancel-title="Cerrar" v-model="previewmodal">
            <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
            <template v-else>
            <template v-if="pdfobject !==''">
                <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
            </template>
            </template>
        </b-modal>
   </div>
</template>

<script>

import axios from 'axios'
export default {
    name: 'vistaPostEmision',
    props: ['idDocumentPreview','tipoDocPreview'],
    data: () => {
        return {
            previewmodal: false,
            cargandopdf2: false,
            pdfobject: '',
            ticketPrevLocal: {
                data: '',
                bandera: false
            },
            tipoDoc: [
                {partUrl:'facturas/pdf'},
                {partUrl:'boletas/pdf'},
                {partUrl:'notacredito/pdf'},
                {partUrl:'notadebito/pdf'},
                {partUrl:'guiaremitente/pdf'},
                {partUrl:'guiaremitente/guiatransportista/pdf'}
            ]
        }
    },
    mounted() {
        this.prev()
    },
    watch: {
        previewmodal: function () {
            if(this.previewmodal){
                this.closeModal(1)
            }else{
                this.closeModal(2)
            }
        }
    },
    methods: {
        prev: function () {
            if(this.idDocumentPreview != 0){
                this.viewPdf(this.tipoDocPreview)
            }else{

            }
        },
        viewPdf: function (value) {
            let urlFinal = ''
            this.previewmodal = true,
            this.pdfobject = '',
            this.cargandopdf2 = true
            switch(value){
                case 1: 
                    urlFinal = this.tipoDoc[0].partUrl
                    break;
                case 2: 
                    urlFinal = this.tipoDoc[1].partUrl
                    break;
                case 3: 
                    urlFinal = this.tipoDoc[2].partUrl
                    break;
                case 4: 
                    urlFinal = this.tipoDoc[2].partUrl
                    break;
                case 5: 
                    urlFinal = this.tipoDoc[4].partUrl
                    break;
                case 6: 
                    urlFinal = this.tipoDoc[5].partUrl
                    break;
            }
            axios
            .post(process.env.VUE_APP_API_URL + urlFinal,{
                token: this.$store.getters.userToken,
                id: this.idDocumentPreview
            })
            .then(response => (
                this.pdfobject = response.data.base64,
                this.cargandopdf2 = false,
                this.$snotify.success(response.data.message, 'Exito')
            ))
            .catch(error => (
                // this.$snotify.error(error.response.data.message, 'Error'),
                this.previewmodal = false
            ))
        },
        closeModal: function (value) {
            this.$emit("closePreview", value);
        }
    }
}
</script>
